const tableInjectionKey = Symbol("ArcoTable");
const tableColumnInjectionKey = Symbol("ArcoTableColumn");
export { tableColumnInjectionKey, tableInjectionKey };
